import List from "./List";
import Create from "./Create";
// import Show from "./Show";
import Edit from "./Edit";

export const TagList = List;
// export const TagShow = Show;
export const TagEdit = Edit;
export const TagCreate = Create;
